import { ApiService } from "../api/services.gen";

export async function getUserDetails() {
  try {
    const user = await ApiService.apiWhoamiRetrieve();
    return {
      id: user.id,
      role: user.role,
      company: user.company,
    };
  } catch (error) {
    console.error("Failed to fetch user details:", error);
    return null;
  }
}
